import { VeteransBenefits } from '../../cards/veterans-benefits';
import { Branch, Card } from '../../components/deck';
import { permittedStates } from './state-verification';

export const VeteranStatusCompleted = (continuation) =>
  Branch(
    {
      veteransIncomplete: Card(VeteransBenefits)
    },
    ({ model }) => {
      const givenState = model.get('loanState') || model.get('preapprovalState');
      const shouldNotDisplayCard =
        permittedStates.includes(givenState) || model.getIn(['loan', 'advisor']);
      return shouldNotDisplayCard ? null : 'veteransIncomplete';
    },
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/veteran-status-completed.js